export default [
    '$rootScope',
    'SPClientData',
    function brandDataFacade($rootScope, SPClientData) {
        $rootScope.brandData = SPClientData.getBrandData();
    }
];
